module.exports = __webpack_public_path__ + "img/24 Animation 2-squashed.30cf8325.jpg";